module.exports = __webpack_public_path__ + "static/media/gato.b4e65139.svg";